export function toKebabCase(string) {
  return string ? string.replace(/_|\s+/g, '-').toLowerCase() : '';
}

export function getTextAfterLastSymbol(text: string, symbol: string): string {
  return text.substring(text.lastIndexOf(symbol) + 1) || text;
}

export function escapeString(string) {
  return (string || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&apos;');
}

export function escapeEmoji(str: string) {
  return str.replace(/\uD83D[\uDE00-\uDE4F]/g, '');
}

export function camelToTitleCase(str) {
  return (
    str
      .replace(/[0-9]{2,}/g, (match) => ` ${match} `)
      .replace(/[^A-Z0-9][A-Z]/g, (match) => `${match[0]} ${match[1]}`)
      .replace(/[A-Z][A-Z][^A-Z0-9]/g, (match) => `${match[0]} ${match[1]}${match[2]}`)
      // eslint-disable-next-line no-unused-vars
      .replace(/[ ]{2,}/g, (_) => ' ')
      .replace(/\s./g, (match) => match.toUpperCase())
      .replace(/^./, (match) => match.toUpperCase())
      .trim()
  );
}

export function getSafeText(text, length, emptyMessage = '') {
  if (text?.length) {
    const escapedText = escapeString(text.slice(0, length));
    const safeText = escapeEmoji(escapedText);

    return `${safeText.trim()}`;
  }

  return emptyMessage;
}

export function normalizeMessage(link: string): string {
  // Normalize the links
  const httpToHttps = link.replace('http://', 'https://');
  const wikiLinkHttpToHttps = httpToHttps
    .split('[')
    .map((element) => element.replace('http://', 'https://'))
    .join('[');

  const wwwToHttps = wikiLinkHttpToHttps.split(' ').map((element) => {
    if (element.startsWith('www')) {
      return `https://${element}`;
    }

    return element;
  });

  let normalizedLink = wwwToHttps.join(' ');

  // Process mail links
  const mailRegex = /(([a-zA-Z0-9\-_.])+@[a-zA-Z_]+?(\.[a-zA-Z]{2,6})+)/gim;

  if (normalizedLink.match(mailRegex)) {
    normalizedLink = normalizedLink.replace(mailRegex, '<a href="mailto:$1">$1</a>');
  }

  // Process links
  const splitText = normalizedLink.split(' ');
  const processedTextArray = splitText.map((element) => {
    if (element.startsWith('https://')) {
      return `<a href="${element}" target="_blank">${element}</a>`;
    }

    return element;
  });

  normalizedLink = processedTextArray.join(' ');

  // Return the normalized link without processing wiki links
  return normalizedLink;
}

export function camelToKebabCase(text: string) {
  let formattedString = text;

  const upperCasedLetters = text.match(/[A-Z]/g);

  if (upperCasedLetters) {
    for (const letter of upperCasedLetters) {
      formattedString = formattedString.replace(letter, `-${letter.toLowerCase()}`);
    }
  }

  return formattedString;
}
